/**
 * Вывод под светильник (бра, подсветка) на чертеже.
 *
 * Обозначение — белый круг с цветным контуром, как принято на электрических схемах, —
 * так вывод не спутать с розеткой того же размера.
 */
import { CatalogSymbol } from "../../CatalogSymbol";
import type { ElementShapeProps } from "../../electrical/2d/ElectricalItemShape";
import { ItemFrame, SELECTED_COLOR } from "../../electrical/2d/ItemFrame";

export const LightShape = ({
	fixture,
	item,
	width,
	height,
	color,
	selected,
	...frame
}: ElementShapeProps) => {
	const px = (n: number) => n * frame.mmPerPx;
	const stroke = selected ? SELECTED_COLOR : color;
	return (
		<ItemFrame
			{...frame}
			fixtureId={fixture.id}
			width={width}
			height={height}
			color={color}
			selected={selected}
			backdrop={
				<ellipse
					cx={0}
					cy={0}
					rx={width / 2}
					ry={height / 2}
					fill="#ffffff"
					stroke={stroke}
					strokeWidth={px(1)}
				/>
			}
		>
			<CatalogSymbol
				item={item}
				width={width * 0.8}
				height={height * 0.8}
				color={stroke}
				mmPerPx={frame.mmPerPx}
			/>
		</ItemFrame>
	);
};
